import { Controller } from "@hotwired/stimulus";
import { create as createWebAuthnJSON, get as getWebAuthnJSON } from "@github/webauthn-json";

export default class extends Controller {
  static targets = ["credentialHiddenInput", "submitButton"];
  static values = { optionsUrl: String }

  connect() {
    this.submitButtonTarget.disabled = false;
  }

  async create() {
    try {
      // Check if WebAuthn is supported
      if (!window.PublicKeyCredential) {
        throw new Error("WebAuthn is not supported in this browser");
      }

      // Check if the library is loaded
      if (typeof createWebAuthnJSON === 'undefined') {
        throw new Error("WebAuthn library not loaded properly");
      }

      const optionsResponse = await fetch(this.optionsUrlValue, {
        method: "POST",
        body: new FormData(this.element),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
        },
      });

      const optionsJson = await optionsResponse.json();
      if (optionsResponse.ok) {
      // Check if the response has the expected structure
      if (!optionsJson.challenge) {
        throw new Error("Invalid WebAuthn options: missing challenge");
      }

      // Debug: Log the options being passed
      console.log("About to call createWebAuthnJSON with:", { publicKey: optionsJson });

      // Use the correct API for @github/webauthn-json v2.1.1
      const credential = await createWebAuthnJSON({ publicKey: optionsJson });

        this.credentialHiddenInputTarget.value = JSON.stringify(credential);

        this.element.submit();
      } else {
        alert(optionsJson.errors?.[0] || "Unknown error");
      }
    } catch (error) {
      console.error("WebAuthn create error:", error);
      console.error("Error details:", {
        message: error.message,
        stack: error.stack,
        userAgent: navigator.userAgent
      });
      alert(`WebAuthn Error: ${error.message}`);
    }
  }

  async get() {
    try {
      // Check if WebAuthn is supported
      if (!window.PublicKeyCredential) {
        throw new Error("WebAuthn is not supported in this browser");
      }

      // Check if the library is loaded
      if (typeof getWebAuthnJSON === 'undefined') {
        throw new Error("WebAuthn library not loaded properly");
      }

      const optionsResponse = await fetch(this.optionsUrlValue, {
        method: "POST",
        body: new FormData(this.element),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
        },
      });

      const optionsJson = await optionsResponse.json();

      if (optionsResponse.ok) {
        // Check if the response has the expected structure
        if (!optionsJson.challenge) {
          throw new Error("Invalid WebAuthn options: missing challenge");
        }

        // Use the correct API for @github/webauthn-json v2.1.1
        const credential = await getWebAuthnJSON({ publicKey: optionsJson });

        this.credentialHiddenInputTarget.value = JSON.stringify(credential);

        this.element.submit();
      } else {
        alert(optionsJson.errors?.[0] || "Unknown error");
      }
    } catch (error) {
      alert(`WebAuthn Error: ${error.message}`);
    }
  }

}
